// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__EBVQK","name":"ConsentHeader_name__a4r6o","birthday":"ConsentHeader_birthday__gYJl2","skeleton":"ConsentHeader_skeleton__1wije"};